import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';

const Barwiththreeset = ({ data }) => {
  const [chartConfig, setChartConfig] = useState({});

  useEffect(() => {
    // Combine design and data
    if (data && data.categories && data.series) {
      const chartOptions = {
        chart: {
          height: 300,
          type: 'bar',
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        colors: ['#EE1D23', '#1A2B5C', '#808080'], // Colors for the 3 bars
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded',
          },
        },
        grid: {
          borderColor: '#e0e6ed',
        },
        xaxis: {
          axisBorder: {
            color: '#e0e6ed',
          },
          categories: data.categories, // x-axis labels
        },
        yaxis: {
          opposite: false,
          labels: {
            offsetX: 0,
          },
        },
        tooltip: {
          theme: 'light',
          y: {
            formatter: (val) => val,
          },
        },
      };

      setChartConfig({
        series: data.series,
        options: chartOptions,
      });
    }
  }, [data]);

  const chartCSS = {
    chartWrapper: 'rounded-lg bg-white dark:bg-black overflow-hidden',
  };

  if (!chartConfig.series || !chartConfig.options) {
    return <div>Loading Chart...</div>;
  }

  return (
    <div className={chartCSS.chartWrapper}>
      <ReactApexChart series={chartConfig.series} options={chartConfig.options} type="bar" height={300} />
    </div>
  );
};

export default Barwiththreeset;
